<template>
  <div v-if="user">
    <el-row v-if="admin_role">
      <el-col :span="24">
        <el-tabs v-model="active" type="border-card">
          <el-tab-pane label="Tracks" name="tracks">
            <Tracks />
          </el-tab-pane>
          <el-tab-pane label="Distro Tracks" name="distro_tracks" v-if="level3">
            <Distro />
          </el-tab-pane>
          <el-tab-pane label="Artists" name="artists" v-if="level3">
            <Artists />
          </el-tab-pane>
          <el-tab-pane label="Labels" name="labels" v-if="level3">
            <Labels />
          </el-tab-pane>
          <el-tab-pane label="Territories Report" name="territories_report" v-if="level3">
            <TerritoriesReport />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <Tracks />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Tracks from '../components/Tracks'
import Artists from '../components/Artists'
import Labels from '../components/Labels'
import TerritoriesReport from '../components/TerritoriesReport'
import store from "../../../../plugins/vuex";
import Distro from "@/modules/admin/new-releases/components/Distro.vue";

export default {
  components: {
    Distro,
    Tracks,
    Artists,
    Labels,
    TerritoriesReport
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['admin_role']),
    level1: function() {
      if (store.state.auth.user.permission === 1) return true
      else {
        return false
      }
    },
    level2: function() {
      if (store.state.auth.user.permission === 2) return true
      else {
        return false
      }
    },
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    }
  },

  data() {
    return {
      active: 'tracks'
    }
  }
}
</script>
